import React, { useEffect, useState } from "react"
import { Button } from "@novaescola/eva-react-v2"
import Cookies from 'js-cookie'
import axios from "axios"

export default function PhoneModal({ onClose,linkRedirect, user, name }) {
  const [phone, setPhone] = useState("")
  const [error, setError] = useState("")

  function phoneMask(value) {
    return value
			.replace(/^\+55|\D/g, '')
      .replace(/^(\d)/, "($1")
      .replace(/^(\(\d{2})(\d)/, "$1) $2")
      .replace(/(\d{5})(\d{1,5})/, "$1-$2")
      .replace(/(-\d{4})\d+?$/, "$1")
  }

  function validarTelefone(inputValue) {
    const numero = inputValue.replace(/\D/g, "")
    const repetido = /^(\d)\1{8}$/.test(numero.substring(2))
    const telefoneRegex = /^[1-9]{2}[9][0-9]{8}$/.test(numero)
    return numero.substring(2).length === 9 && !repetido && telefoneRegex
  }

  const handlePhoneSubmit = async () => {
    if (!validarTelefone(phone)) {
      setError("Por favor, insira um número de telefone válido no formato (xx) xxxxx-xxxx.")
      return
    }
    const pdfData = {
        "wa_id": phone,
    "resource_metadata": {
        "s3_uri": linkRedirect,
        "name": name || "Material",
        "type": "Material Educacional"
    },
    "namespace": process.env.GATSBY_ASSISTANTS_NAMESPACE,
    "template_name": "material_teste2"
    }
      try {
        await axios.post(
        "https://api.dev.novaescola.org.br/assistants/turn/send-pdf-wpp",
        pdfData,
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("Bearer")}`,
            apikey: process.env.GATSBY_ASSISTANTS_API_KEY
            }
        }
        )

        setError("")
        onClose()
    } catch (error) {
        console.error("Erro ao enviar PDF via WhatsApp:", error)
        setError("Ocorreu um erro ao enviar o PDF. Tente novamente mais tarde.")
    }
    }
    
    useEffect(() => {
        if(user && user.telefone1)
        setPhone(phoneMask(user.telefone1))
    },[user])

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          width: "90%",
          maxWidth: "800px",
                  position: "relative",
                  display: "flex",
          justifyContent:"center",
                  alignItems: "center",
          flexDirection:"column"
        }}
        onClick={(e) => e.stopPropagation()}
          >
        <div style={{width:"100%", display: "flex", justifyContent:"end"}}>
            <span
                onClick={onClose}
                style={{
                    color: "#aaa",
                    float: "right",
                    fontSize: "28px",
                    fontWeight: "bold",
                    cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.color = "black")}
                onMouseOut={(e) => (e.target.style.color = "#aaa")}
                >
                &times;
            </span>
        </div>
                  
        <h1 style={{fontSize:"22px",fontWeight: 700, margin:"15px 0", textAlign:"center", color:"black"}}>Insira seu Whatsapp para receber o PDF!</h1>
        <p style={{fontSize:"17px", margin:"15px 0", textAlign:"center", color:"black"}}>Preencha com o seu número de telefone</p>

        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(phoneMask(e.target.value))}
          placeholder="(xx) xxxxx-xxxx"
          maxLength={15}
          style={{
            width: "50%",
            padding: "8px",
            fontSize: "16px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            color: "black"
          }}
        />

        {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px", gap: "10px" }}>
          <Button variant="primary" onClick={async ()=> await handlePhoneSubmit()}>
            Enviar
          </Button>
        </div>
      </div>
    </div>
  )
}
